module.exports = __webpack_public_path__ + "media/images/sp/specials/common/frequent/coming_soon-3802c9126b5b4ec9609515a958139645.jpg";